(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .directive("modalCampaignSettingsContent", modalCampaignSettingsContent);

    /** @ngInject */
    function modalCampaignSettingsContent() {
        return {
            restrict: "E",
            scope: {
                onClose: "&",
                onExpose: "&",
                response: "=",
                isValid: "="
            },
            controller: 'ModalCampaignSettingsContentController',
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "app/components/modal/side-modal/body-contents/campaign-settings/campaign-settings-content.html",
            link: function (scope, element, attrs, ctrl) {
                if (ctrl && typeof scope.vm.onExpose === 'function') {
                    scope.vm.onExpose({ methods: { applyFilters: ctrl.save, closeModal: ctrl.close, isFormInvalid: ctrl.isFormInvalid } });
                }
            }
        };
    }
})();
